<template>
  <div class="page">
    <a-card title="新建优惠券" :bordered="false" :bodyStyle="{paddingTop:'10px'}"
            :headStyle="{ borderBottom: '0px', fontSize: '18px' }">
      <a-form-model ref="ruleForm" :model="ruleForm" :rules="rules" :disabled="true"
                    :label-col="currentFormLayout.labelCol"
                    :wrapper-col="currentFormLayout.wrapperCol"
      >
        <div class="content-list">
          <div class="item-content" v-if="vesion!=1" :class="{'active':ruleForm.couponUseType==1}"
               @click="onEventUseType(1)">
            <div class="main-title">满立减</div>
            <div class="vice-tltle">如满100减50</div>
          </div>
          <div class="item-content" v-if="vesion==3" :class="{'active':ruleForm.couponUseType==3}"
               @click="onEventUseType(3)">
            <div class="main-title">满份减</div>
            <div class="vice-tltle">如满2份减50</div>
          </div>
          <div class="item-content" v-if="vesion==3" :class="{'active':ruleForm.couponUseType==4}"
               @click="onEventUseType(4)">
            <div class="main-title">早买减</div>
            <div class="vice-tltle">如提前2天买减50</div>
          </div>
          <div class="item-content" :class="{'active':ruleForm.couponUseType==2}" @click="onEventUseType(2)">
            <div class="main-title">无门槛</div>
            <div class="vice-tltle">如0元起可用</div>
          </div>
        </div>
        <a-form-model-item v-if="ruleForm.couponUseType==1" prop="couponUseLimitAmt" label="满">
          <a-input v-model="ruleForm.couponUseLimitAmt" prefix="￥" :maxLength="14" suffix="RMB" addonAfter="元可用"
                   placeholder="0.01起" class="maxW250"/>
        </a-form-model-item>
        <a-form-model-item v-if="ruleForm.couponUseType==3" prop="payCount" label="满">
          <a-input v-model="ruleForm.payCount" :maxLength="5" addonAfter="份可用" placeholder="1份起" class="maxW250"/>
        </a-form-model-item>
        <a-form-model-item v-if="ruleForm.couponUseType==4" prop="advanceDays" label="提前">
          <a-input v-model="ruleForm.advanceDays" :maxLength="5" placeholder="1天起" class="maxW250">
            <a-tooltip slot="addonAfter" title="*非日历价格的商品不可用，如抢购、百货类">
              <span class="a-tips">天下单可用</span>
            </a-tooltip>
          </a-input>
        </a-form-model-item>
        <a-form-model-item prop="couponAmout" label="面额">
          <a-input v-model="ruleForm.couponAmout" prefix="￥" :maxLength="14" suffix="RMB" placeholder="0.01起"
                   class="maxW250"/>
        </a-form-model-item>
        <a-form-model-item prop="couponNumType" label="数量">
          <a-col :span="6">
            <a-select allowClear v-model="ruleForm.couponNumType" placeholder="请选择" class="maxW250">
              <a-select-option :value="1">不限</a-select-option>
              <a-select-option v-if="vesion==3" :value="2">限量</a-select-option>
            </a-select>
          </a-col>
          <a-col :span="8">
            <a-form-model-item v-if="ruleForm.couponNumType==2" prop="couponNumLimit">
              <a-input v-model="ruleForm.couponNumLimit" addonAfter="张" placeholder="1-100000" :maxLength="10"
                       style="max-width:150px"/>
            </a-form-model-item>
          </a-col>
        </a-form-model-item>
        <a-form-model-item prop="couponName" label="优惠券名称">
          <a-input v-model="ruleForm.couponName" :maxLength="20" placeholder="请输入名称，不超过20个字"
                   style="max-width:400px"/>
        </a-form-model-item>
        <a-form-model-item prop="couponProType" label="适用商品来源" required>
          <a-radio-group v-model="ruleForm.couponProType" name="radioGroup" @change="changeProType">
            <a-radio :value="0">自有商品</a-radio>
            <a-radio :value="1">平台直采</a-radio>
            <a-radio :value="2">云仓分销</a-radio>
            <a-radio :value="3">全部来源</a-radio>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item prop="couponProUseType" label="适用商品" required>
          <a-col :span="6">
            <a-select allowClear @change="handleChangeProType" v-model="ruleForm.couponProUseType" placeholder="请选择"
                      style="max-width:200px">
              <a-select-option :value="1">全部品类</a-select-option>
              <a-select-option :value="2">限品类可用</a-select-option>
              <a-select-option :value="3">指定商品可用</a-select-option>
              <a-select-option :value="4">部分商品可用</a-select-option>
            </a-select>
          </a-col>
          <a-col :span="18">
            <a-form-model-item v-if="ruleForm.couponProUseType==2">
              <a-checkbox-group v-model="couponProtypelist">
                <a-checkbox v-for="item in proCataLogIdList" :key="item.code" :value="String(item.code)">{{ item.name }}
                </a-checkbox>
              </a-checkbox-group>
            </a-form-model-item>
            <div v-if="ruleForm.couponProUseType == 3" class="formblock">
              <a-button @click="openCouponDialog(1)" style="margin-left:10px">选择</a-button>
              <span v-if="ruleForm.couponUseProId"
                    class="pl10">商品ID：{{ ruleForm.couponUseProId }} 商品名称：{{ ruleForm.couponProName }}</span>
            </div>
            <a-form-model-item v-if="ruleForm.couponProUseType == 4" style="margin-bottom:0;">
              <a-button @click="openCouponDialog(2)" style="margin-left:8px;">选择</a-button>
              <a-input v-model="ruleForm.couponUseProId" disabled placeholder="输入商品ID多个以英文','隔开，最多10个"
                       :maxLength="200"
                       style="max-width:480px;margin:0 8px;"/>
              <a-button v-if="ruleForm.couponUseProId" @click="deleteCouponUseProId" type="danger" ghost>删除</a-button>
            </a-form-model-item>
          </a-col>
        </a-form-model-item>
        <a-form-model-item prop="couponGetDate" label="领取时间">
          <a-range-picker name="buildTime" :disabledDate="disabledDate"
                          v-model="ruleForm.couponGetDate"
                          @change="onDateGetDateChange" show-time
                          format="YYYY-MM-DD HH:mm:ss"/>
        </a-form-model-item>
        <a-form-model-item prop="couponUseDate" label="可用时间">
          <a-range-picker name="buildTime" :disabledDate="disabledDate"
                          v-model="ruleForm.couponUseDate"
                          @change="onDateUseChange"
                          show-time
                          format="YYYY-MM-DD HH:mm:ss"/>
        </a-form-model-item>
        <a-form-model-item label="领取方式" required>
          <a-col :span="6">
            <a-cascader allowClear
                        :options="getWayArrlist()"
                        :value='defaultWayValue'
                        changeOnSelect placeholder="请选择领取方式"
                        @change="onGetWayChange"/>
          </a-col>
          <a-col :span="18">
            <a-form-model-item v-if="ruleForm.couponGetWay==4" prop="couponGetWaYLimitAmt" style="margin-bottom:0;">
              <a-input v-model="ruleForm.couponGetWaYLimitAmt" :maxLength="10" addonAfter="元派券" placeholder="0.01起"
                       class="maxW250"/>
            </a-form-model-item>
            <a-form-model-item v-if="ruleForm.couponGetWay==5" prop="payProId" style="margin-bottom:0;">
              <a-button @click="openCouponDialog(3)" style="margin-left:8px;">选择</a-button>
              <a-input v-model="ruleForm.payProId" disabled :maxLength="100" placeholder="商品ID多个,隔开"
                       style="max-width:480px;margin:0 8px;"/>
              <a-button v-if="ruleForm.payProId" @click="deletePayProId" type="danger" ghost>删除</a-button>
            </a-form-model-item>
          </a-col>
        </a-form-model-item>
        <a-form-model-item label="领取限制" required>
          <a-form-model-item prop="couponGetLimitNum">
            <span class="pr10">每个用户最多可领取</span>
            <a-input v-model="ruleForm.couponGetLimitNum" :maxLength="10" addonAfter="次" class="maxW250"/>
          </a-form-model-item>
          <a-form-model-item prop="couponGetLimitType">
            <a-radio-group v-model="ruleForm.couponGetLimitType" name="radioGroup">
              <a-radio :value="1">限本店用户领取</a-radio>
              <a-radio v-if="vesion!=1" :value="2">限本店及二级分销店用户领取</a-radio>
              <!-- <a-radio v-if="vesion==3&&ruleForm.couponProType==0" :value="3">所有店均可领取（含平台直采分销店，若设置，订单实收金额可能小于同行价）</a-radio> -->
            </a-radio-group>
          </a-form-model-item>
        </a-form-model-item>
        <a-form-model-item :wrapper-col="currentFormLayout.offsetCol">
          <a-button v-if="status==0" type="primary" @click="handleSubmit" :loading="submitLoading">保存设置</a-button>
          <a-button v-if="status==0" @click="resetForm">取消</a-button>
          <a-button v-if="status==1" :disabled="false" @click="overbtn">提前结束</a-button>
        </a-form-model-item>
      </a-form-model>
    </a-card>
    <!-- 与产品沟通采用商品库列表 -->
    <selected-product-dialog
      :show="showSelectedDialog"
      ref="pageList"
      :itemNames="['search_proId','search_proName']"
      :query-params="selectedQueryParams"
      :requestPromise="loadPromise"
      row-key="proId"
      @close="showSelectedDialog=false"
      :columns="getGoodsColumns()"
    >
      <a-form-item label="商品ID" slot="search_proId" v-bind="currentDialogLayout">
        <a-input v-model="selectedQueryParams.proId" style="width: 170px" placeholder="请输入商品ID"></a-input>
      </a-form-item>
      <a-form-item label="商品名称" slot="search_proName" v-bind="currentDialogLayout">
        <a-input v-model="selectedQueryParams.proName" style="width: 170px" placeholder="请输入商品名称"></a-input>
      </a-form-item>
      <template slot="proTypeSlot" slot-scope="rowItem">{{ rowItem.text|productTypeName }}</template>
      <template slot="action" slot-scope="rowItem">
        <a-button type="primary" @click="onSelectedResult(rowItem.record)">选择</a-button>
      </template>
    </selected-product-dialog>
    <a-modal
      title="提示"
      :visible="proTypeVisible"
      :footer="null"
      :closable="false"
      :maskClosable="false"
    >
      <p>选择“全部来源”将可能出现亏损问题，如销售实收金额小于供应商的结算价，继续选择产生亏损将自行承担！</p>
      <div style="height: 30px">
        <a-button style="float:right;" type="primary" @click="handleOk">确定</a-button>
      </div>
    </a-modal>
  </div>
</template>

<script>
//vesion:1,//优惠劵版本 1位免费版 2为尊享版 3 白金版
import { mapState } from 'vuex'
import moment from 'moment'
import SelectedProductDialog from '@/customComponents/SelectedProductDialog/SelectedProductDialog'

export default {
  name: 'NewCoupon',
  components: {
    SelectedProductDialog
  },
  data() {
    var checkNum = (rule, value, callback) => {
      setTimeout(() => {
        if (Number(value) > Number(100000)) {
          callback(new Error('数量必须要小于100000'))
        } else {
          callback()
        }
      }, 1000)
    }
    return {
      moment,
      proTypeVisible: false,
      showSelectedDialog: false,
      couponId: this.$route.query.couponId,
      status: this.$route.query.status,
      ifDisabled: this.$route.query.status == 0 ? false : true,
      couponProtypelist: [],
      submitLoading: false,
      defaultWayValue: [1],
      selectedQueryParams: {
        proName: '',
        proId: '',
        proSource: 0
      },
      currentDialogLayout: {
        labelCol: { span: 6 },
        wrapperCol: { span: 18 }
      },
      currentFormLayout: {
        labelCol: {
          xxl: { span: 3 },
          xl: { span: 3 },
          lg: { span: 3 },
          sm: { span: 3 },
          md: { span: 5 },
          xs: { span: 10 }
        },
        wrapperCol: {
          xxl: { span: 21 },//≥1600px 响应式栅格，可为栅格数或一个包含其他属性的对象
          xl: { span: 21 },//≥1200px 响应式栅格，可为栅格数或一个包含其他属性的对象
          lg: { span: 21 },//≥992px 响应式栅格，可为栅格数或一个包含其他属性的对象
          sm: { span: 21 },//≥768px 响应式栅格，可为栅格数或一个包含其他属性的对象
          md: { span: 16 },//≥576px 响应式栅格，可为栅格数或一个包含其他属性的对象
          xs: { span: 14 }//xs	<576px 响应式栅格，可为栅格数或一个包含其他属性的对象
        },
        offsetCol: {
          xxl: { offset: 3 },//≥1600px 响应式栅格，可为栅格数或一个包含其他属性的对象
          xl: { offset: 3 },//≥1200px 响应式栅格，可为栅格数或一个包含其他属性的对象
          lg: { offset: 3 },//≥992px 响应式栅格，可为栅格数或一个包含其他属性的对象
          sm: { offset: 3 },//≥768px 响应式栅格，可为栅格数或一个包含其他属性的对象
          md: { offset: 5 },//≥576px 响应式栅格，可为栅格数或一个包含其他属性的对象
          xs: { offset: 10 }//xs	<576px 响应式栅格，可为栅格数或一个包含其他属性的对象
        }
      },
      ruleForm: {
        couponProType: 0,  // '商品类型'
        couponAmout: '',//优惠券金额
        couponGetStartTime: '',//领取开始时间
        couponGetEndTime: '',//领取结束时间
        couponGetLimitNum: 1,//领取限制数量
        couponGetLimitType: 1,//领取限制类型（1，限本店用户领取，2,，限本店及二分领取，3，本店及一二分销领取） ,
        couponGetWaYLimitAmt: '',//领取限制金额
        couponGetWay: 1,//领取方式（1，商品页领取，2，分享页领取，3，弹窗领取，支付后领取）
        couponId: this.$route.query.couponId == 0 ? null : this.$route.query.couponId,
        couponMerchantId: this.$store.getters.userInfo.merchantId,
        couponName: '',//优惠券名称 ,
        couponNumLimit: '',//发放数量
        couponNumType: 1,//数量发放类型（1，不限量，2，限量,
        couponPlatformId: this.getPlatformConfig().platformId,
        couponProUseType: undefined,//适用商品（1，全品类，2，限品类可用，3，指定商品可用）
        couponUseEndTime: '',//使用结束时间
        couponUseLimitAmt: '',//最低使用金额
        couponUseProId: '',//相关适用商品，跟proUseType配合使用 ,
        couponUseStartTime: '',//使用开始时间
        couponUseType: 1,//使用类型（1，满立减，2，无门槛）
        couponProName: '',
        payCount: '',//满份减
        payProId: '',//支付
        advanceDays: '',//早买减
        couponGetDate: undefined,
        couponUseDate: undefined
      },
      rules: {
        couponName: [
          { required: true, message: '请输入优惠券名称', trigger: 'blur' }
        ],
        type: [
          { required: true, message: '请选择优惠券类型', trigger: 'blur' }
        ],
        couponUseLimitAmt: [
          { required: true, message: '请输入满立减金额', trigger: 'blur' },
          {
            pattern: /^(?!0+(?:\.0+)?$)(?:[1-9]\d{0,7}|0)(?:\.\d{1,2})?$/,
            message: '请输入正确的金额',
            trigger: 'blur'
          }
        ],
        payCount: [
          { required: true, message: '请输入满用条件', trigger: 'blur' },
          { pattern: /^[1-9]\d*$/, message: '请输入正确的条件', trigger: 'blur' }
        ],
        advanceDays: [
          { required: true, message: '请输入满用条件', trigger: 'blur' },
          { pattern: /^[1-9]\d*$/, message: '请输入正确的条件', trigger: 'blur' }
        ],
        couponAmout: [
          { required: true, message: '请输入面额金额', trigger: 'blur' },
          {
            pattern: /^(?!0+(?:\.0+)?$)(?:[1-9]\d{0,7}|0)(?:\.\d{1,2})?$/,
            message: '请输入正确的金额',
            trigger: 'blur'
          }
        ],
        couponGetWaYLimitAmt: [
          { required: true, message: '请输入支付满金额', trigger: 'blur' },
          { pattern: /^([1-9]\d{0,9}|0)([.]?|(\.\d{1,2})?)$/, message: '请输入正确的金额', trigger: 'blur' }
        ],
        payProId: [
          { required: true, message: '请选择商品ID', trigger: 'blur' }
        ],
        couponUseType: [
          { required: true, message: '请选择类型', trigger: 'change' }
        ],
        couponProUseType: [
          { required: true, message: '请选择适用商品类型', trigger: 'change' }
        ],
        couponNumLimit: [
          { required: true, message: '请选择限量数值', trigger: 'blur' },
          { pattern: /^[1-9]\d*$/, message: '请输入正确的限量数值', trigger: 'blur' },
          { validator: checkNum, trigger: 'blur' }
        ],
        couponGetLimitNum: [
          { required: true, message: '请选择最多领取数', trigger: 'blur' },
          { pattern: /^[1-9]\d*$/, message: '请输入正确的领取数', trigger: 'blur' }
        ],
        couponGetDate: [
          { required: true, message: '请选择领取日期', trigger: 'change' }
        ],
        couponUseDate: [
          { required: true, message: '请选择可用日期', trigger: 'change' }
        ]
      },
      disabledDate(current) {
        // Can not select days before today and today
        return current && current < moment().startOf('day')
      },
      proCataLogIdList: [],
      submitFormData: '',
      getWaylist: [
        {
          value: 1,
          label: '商品页领取',
          children: []
        },
        {
          value: 2,
          label: '分享页领取',
          children: []
        },
        {
          value: 3,
          label: '弹窗领取',
          children: []
        },
        {
          value: 4,
          label: '支付后领取',
          children: [
            {
              value: 4,
              label: '支付满'
            },
            {
              value: 5,
              label: '支付指定商品'
            }
          ]
        }
      ],
      selectedRowKeys: [],
      selectedRows: [],
      multiNum: 1,
      closeNumber: 0,
      loadPromise: params => this.getListPromise(params)
    }
  },
  mounted() {
    this.getProCataLogId()
  },
  computed: {
    //state.config.serverDataInfo.vesion
    ...mapState({
      // 获取版本
      vesion: state => state.config.serverDataInfo.vesion
    })
  },
  watch: {
    // 'ruleForm.couponProUseType': {
    //   handler(val, oldVal) {
    //     this.ruleForm.couponUseProId = ''
    //     this.ruleForm.couponProName = ''
    //     this.getLogUtils().logWithTag('更新适用来源', val, this.ruleForm.couponUseProId)
    //   }
    // }
  },
  activated() {
    this.getLogUtils().logWithTag('优惠券activated', '优惠券activated')
    this.$store.commit('SET_RECHARGE', true)
    this.$store.commit('SET_MENU_HEAD_CONFIG', [
      { name: 'CouponServiceList', title: '优惠券列表' },
      { name: 'CouponRuleList', title: '规则列表' }
    ])
    this.getNewData()
  },
  methods: {
    handleChangeProType() {
      this.ruleForm.couponUseProId = ''
      this.ruleForm.couponProName = ''
    },
    getNewData() {
      this.couponId = this.$route.query.couponId
      this.status = this.$route.query.status
      this.ruleForm.couponId = this.$route.query.couponId == 0 ? null : this.$route.query.couponId
      this.ifDisabled = this.$route.query.status == 0 ? false : true
      this.selectedRowKeys = []
      this.selectedRows = []
      this.multiNum = 1
      this.couponProtypelist = []
      this.defaultWayValue = [1]
      this.submitLoading = false
      this.selectedQueryParams.proSource = 0
      this.getCouponData()
    },
    // '选择商品类型'
    changeProType(e) {
      this.getLogUtils().logWithTag('changeProType', `checked = ${e.target.value}`)
      this.selectedQueryParams.proSource = e.target.value
      if (this.ruleForm.couponProType == 3) {
        this.proTypeVisible = true
      }
    },
    // 选择商品弹窗
    handleOk() {
      if (this.closeNumber < 2) {
        this.proTypeVisible = false
        setTimeout(() => {
          this.proTypeVisible = true
        }, 500)
        this.closeNumber += 1
      } else {
        this.proTypeVisible = false
        this.closeNumber = 0
      }
    },
    openCouponDialog(type) {
      this.multiNum = type
      this.showSelectedDialog = true
      if (this.multiNum == 3 || this.ruleForm.couponProType == 3) {
        this.selectedQueryParams.proSource = ''
      } else {
        this.selectedQueryParams.proSource = this.ruleForm.couponProType
      }
      setTimeout(() => {
        this.$refs.pageList.refresh(true)
      }, 500)
    },
    //表格数据
    getListPromise(params) {
      console.error('getListPromise', params)
      return this.getHttpServices().getProService().post('api/v2/productManage/findProductList', params)
    },
    // 选择商品
    confirmProduct() {
      if (this.selectedRowKeys.length > 0) {
        if (this.selectedRowKeys.length > 10) {
          this.$message.error('最多10个适用商品')
        } else {
          let str = this.selectedRowKeys.join(',')
          let nameList = this.selectedRows.map((item) => {
            return item.proName
          })
          this.getLogUtils().logWithTag('==nameList==', nameList)
          if (this.multiNum == 2) {
            this.ruleForm.couponUseProId = str
            this.ruleForm.couponProName = nameList.join(',')
          } else if (this.multiNum == 3) {
            this.ruleForm.payProId = str
          }
          this.showSelectedDialog = false
          this.getLogUtils().logWithTag('==couponUseProId==', this.ruleForm.couponUseProId)
        }
      } else {
        this.$message.error('请选择商品')
      }
    },
    resetForm() {
      this.$refs.ruleForm.resetFields()
    },
    // 获取商品状态
    getProCataLogId() {
      this.getHttpServices().getProService().get('product/info/getProCataLogId')
        .then(res => {
          this.getLogUtils().logWithTag('==getProCataLogId==', res)
          res.forEach((item, index) => {
            if (item.code != 83 && item.code != 6 && item.code != 7) {
              this.proCataLogIdList.push(item)
            }
          })
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    // 选择优惠券
    onEventUseType(value) {
      this.ruleForm.couponUseType = value
    },
    //领取日期
    onDateGetDateChange(dates, dateStrArr) {
      this.getLogUtils().logWithTag('onDateGetDateChange', dates)
      this.getLogUtils().logWithTag('onDateGetDateChange', dateStrArr)
      this.ruleForm.couponGetDate = dates
      this.ruleForm.couponGetStartTime = dateStrArr[0]
      this.ruleForm.couponGetEndTime = dateStrArr[1]
      this.ruleForm = {
        ...this.ruleForm
      }
    },
    //可用日期
    onDateUseChange(dates, dateStrArr) {
      this.getLogUtils().logWithTag('onDateUseChange', dates)
      this.getLogUtils().logWithTag('onDateUseChange', dateStrArr)
      this.ruleForm.couponUseDate = dates
      this.ruleForm.couponUseStartTime = dateStrArr[0]
      this.ruleForm.couponUseEndTime = dateStrArr[1]
    },
    //验证
    checkForm() {
      if (this.ruleForm.couponProUseType == 2) {
        if (this.couponProtypelist.length < 1) {
          this.$message.error('请勾选商品类型')
          return false
        }
      }
      if (this.ruleForm.couponProUseType == 3) {
        if (!this.ruleForm.couponProName) {
          this.$message.error('请选择使用优惠劵商品')
          return false
        }
      }
      if (this.ruleForm.couponProUseType == 4) {
        if (!this.ruleForm.couponUseProId) {
          this.$message.error('请选择使用优惠劵商品')
          return false
        }
      }
      return true
    },
    handleSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          if (this.checkForm()) {
            this.submitData()
          }
        } else {
          this.getLogUtils().logWithTag('错误', 'error submit!!')
          return false
        }
      })
    },
    submitData() {
      if (this.ruleForm.couponProUseType == 2) {
        this.ruleForm.couponUseProId = this.couponProtypelist.join(',')
      }
      this.submitFormData = JSON.parse(JSON.stringify(this.ruleForm))
      delete this.submitFormData.couponGetDate
      delete this.submitFormData.couponUseDate
      this.submitLoading = true
      this.getHttpServices().getServerApiService().post('coupon/setting/addOrUpdateCouponSetting', this.submitFormData).then(res => {
        this.getLogUtils().logWithTag('submitData', res)
        this.$message.success('优惠劵保存成功')
        setTimeout(() => {
          this.$router.push({
            name: 'CouponServiceList',
            query: {
              serverUniqueId: this.$route.query.serverUniqueId,
              updateFlag: true
            }
          })
        }, 500)
      }).catch(reason => this.showNetWorkErrorMessage(reason)).finally(() => this.submitLoading = false)
    },
    // 获取领取方式
    onGetWayChange(value, selectedOptions) {
      this.getLogUtils().logWithTag('value', value)
      this.getLogUtils().logWithTag('selectedOptions', selectedOptions)
      if (value && value.length) {
        if (value.length == 2) {
          this.defaultWayValue = [value[0], value[1]]
          this.ruleForm.couponGetWay = value[1]
        } else {
          this.ruleForm.couponGetWay = value[0]
          this.defaultWayValue = [value[0]]
        }
      } else {
        this.defaultWayValue = []
      }

    },
    getWayArrlist() {
      let list = []
      if (this.vesion == 3) {
        list = this.getWaylist
      } else if (this.vesion == 2) {
        list = [
          { value: 1, label: '商品页领取', children: [] },
          { value: 3, label: '弹窗领取', children: [] }
        ]
      } else {
        list = [{ value: 1, label: '商品页领取', children: [] }]
      }
      return list
    },
    getGoodsColumns() {
      return [
        {
          title: '商品ID',
          dataIndex: 'proId',
          width: '100px'
        },
        {
          title: '商品名称',
          dataIndex: 'proName'
        },
        {
          title: '商品分类',
          dataIndex: 'proType',
          width: '100px',
          scopedSlots: { customRender: 'proTypeSlot' }
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '100px',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ]
    },
    // 选择商品
    onSelectedResult(data) {
      this.getLogUtils().logWithTag('onSelectedResult', data)
      if (this.multiNum == 1) {
        this.ruleForm.couponUseProId = data.proId
        this.ruleForm.couponProName = data.proName
        this.showSelectedDialog = false
      } else if (this.multiNum == 2) {
        this.getcouponUseProInfo(data)
      } else if (this.multiNum == 3) {
        // this.ruleForm.payProId
        this.getPayProIdInfo(data)
      }
    },
    getPayProIdInfo(data) {
      if (this.selectedRows.length > 0) {
        if (this.selectedRows.length > 9) {
          this.$message.error('最多10个适用商品')
          return
        }
        let flag = false
        this.selectedRows.forEach((item) => {
          if (item == data.proId) {
            this.$message.error('请勿重复选择商品')
            flag = true
          }
        })
        if (!flag) {
          this.selectedRows.push(data.proId)
          this.showSelectedDialog = false
        }
      } else {
        this.selectedRows.push(data.proId)
        this.showSelectedDialog = false
      }
      this.ruleForm.payProId = this.selectedRows.join(',')
      this.getLogUtils().logWithTag('选中的商品ID', this.ruleForm.payProId)
    },
    // 清除选择的商品
    deletePayProId() {
      this.selectedRows = []
      this.ruleForm.payProId = ''
    },
    getcouponUseProInfo(data) {
      if (this.selectedRowKeys.length > 0) {
        if (this.selectedRowKeys.length > 9) {
          this.$message.error('最多10个适用商品')
          return
        }
        let flag = false
        this.selectedRowKeys.forEach((item) => {
          if (item == data.proId) {
            this.$message.error('请勿重复选择商品')
            flag = true
          }
        })
        if (!flag) {
          this.selectedRowKeys.push(data.proId)
          this.showSelectedDialog = false
        }
      } else {
        this.selectedRowKeys.push(data.proId)
        this.showSelectedDialog = false
      }
      this.ruleForm.couponUseProId = this.selectedRowKeys.join(',')
      this.getLogUtils().logWithTag('选中的商品ID', this.ruleForm.couponUseProId)
    },
    // 清除选择的商品
    deleteCouponUseProId() {
      this.selectedRowKeys = []
      this.ruleForm.couponUseProId = ''
    },
    // 获取优惠券信息
    getCouponData() {
      if (this.couponId != 0) {
        this.getHttpServices().getServerApiService().post('coupon/setting/getCouponSetting/' + this.couponId).then(res => {
          this.getLogUtils().logWithTag('submitData', res)
          this.ruleForm = res
          if (this.ruleForm.couponProUseType == 2) {
            this.couponProtypelist = this.ruleForm.couponUseProId.split(',')
          }
          if (this.ruleForm.couponGetWay == 4) {
            this.defaultWayValue = [4, 4]
          } else if (this.ruleForm.couponGetWay == 5) {
            this.defaultWayValue = [4, 5]
          } else {
            this.defaultWayValue = [Number(this.ruleForm.couponGetWay)]
          }
          this.ruleForm.couponGetDate = this.getDateHelper().getDateMoments(res.couponGetStartTime, res.couponGetEndTime)
          this.ruleForm.couponUseDate = this.getDateHelper().getDateMoments(res.couponUseStartTime, res.couponUseEndTime)
          this.getLogUtils().logWithTag('couponProtypelist', this.couponProtypelist)
        }).catch(reason => this.showNetWorkErrorMessage(reason))
      } else {
        this.ruleForm = {
          couponProType: 0,  // '商品类型'
          couponAmout: '',//优惠券金额
          couponGetStartTime: '',//领取开始时间
          couponGetEndTime: '',//领取结束时间
          couponGetLimitNum: 1,//领取限制数量
          couponGetLimitType: 1,//领取限制类型（1，限本店用户领取，2,，限本店及二分领取，3，本店及一二分销领取） ,
          couponGetWaYLimitAmt: '',//领取限制金额
          couponGetWay: 1,//领取方式（1，商品页领取，2，分享页领取，3，弹窗领取，支付后领取）
          couponId: this.$route.query.couponId == 0 ? null : this.$route.query.couponId,
          couponMerchantId: this.$store.getters.userInfo.merchantId,
          couponName: '',//优惠券名称 ,
          couponNumLimit: '',//发放数量
          couponNumType: 1,//数量发放类型（1，不限量，2，限量,
          couponPlatformId: this.getPlatformConfig().platformId,
          couponProUseType: undefined,//适用商品（1，全品类，2，限品类可用，3，指定商品可用）
          couponUseEndTime: '',//使用结束时间
          couponUseLimitAmt: '',//最低使用金额
          couponUseProId: '',//相关适用商品，跟proUseType配合使用 ,
          couponUseStartTime: '',//使用开始时间
          couponUseType: 1,//使用类型（1，满立减，2，无门槛）
          couponProName: '',
          payCount: '',//满份减
          payProId: '',//支付
          advanceDays: '',//早买减
          couponGetDate: undefined,
          couponUseDate: undefined
        }
      }
    },
    // 提前结束
    overbtn() {
      this.getHttpServices().getServerApiService().post('coupon/setting/finishCouponSetting/' + this.couponId).then(res => {
        this.getLogUtils().logWithTag('overbtn', res)
        this.$message.success('优惠劵提前结束成功')
        setTimeout(() => {
          this.$router.push({
            name: 'CouponServiceList',
            query: {
              serverUniqueId: this.$route.query.serverUniqueId,
              updateFlag: true
            }
          })
        }, 500)
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    }
  }
}
</script>
<style lang="less" scoped>
.ant-btn + .ant-btn {
  margin-left: 10px;
}

.a-tips {
  cursor: pointer;
}

.content-list {
  padding-left: 30px;
  display: flex;
  align-items: center;
  margin-bottom: 15px;

  .item-content {
    height: 52px;
    border: 1px solid #e9e9e9;
    border-radius: 2px;
    margin-right: 15px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 0 8px;
    cursor: pointer;

    &:last-child {
      margin-right: 0;
    }

    .main-title {
      font-size: 14px;
    }

    .vice-tltle {
      font-size: 10px;
      color: rgba(0, 0, 0, 0.309804);
    }
  }

  .active {
    background: rgba(255, 115, 0, 0.254902);
    border: 1px solid rgba(255, 119, 0, 1);
    color: #000;
  }
}

.pr10 {
  padding-right: 10px;
}

.formblock {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.pl10 {
  padding-left: 10px;
}

.maxW250 {
  max-width: 250px;
}

.dialogBtn {
  display: flex;
  justify-content: flex-end;
}
</style>